var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"items":_vm.weekdayItems,"item-text":"label","item-value":"value","multiple":_vm.multi},model:{value:(_vm.data),callback:function ($$v) {_vm.data=$$v},expression:"data"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }